import { MapPin, Phone, MessageCircle } from "lucide-react";
import { PHONE, whatsappLink, CATALOGUE_URL } from "@/lib/api";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 bg-black" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <h3 className="font-display font-black text-xl text-white">
            SHREE <span className="text-[#FF3B30]">PETEANJANEYA</span>
          </h3>
          <p className="text-xs tracking-[0.2em] uppercase text-gray-500 font-bold mt-1">Swamy Enterprises</p>
          <p className="text-gray-400 text-sm mt-4 max-w-xs">{t("footer.tagline")}</p>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-gray-500 font-bold mb-4">{t("footer.visit")}</p>
          <p className="flex items-start gap-3 text-gray-300 text-sm">
            <MapPin size={18} className="text-[#FF3B30] shrink-0 mt-0.5" />
            Yelahanka, Kogilu Circle,<br />Bengaluru — 560064, Karnataka
          </p>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-gray-500 font-bold mb-4">{t("footer.contact")}</p>
          <div className="flex flex-col gap-3">
            <a href={`tel:${PHONE}`} className="flex items-center gap-3 text-gray-300 hover:text-white text-sm transition-colors" data-testid="footer-call">
              <Phone size={18} className="text-[#FF3B30]" /> {PHONE}
            </a>
            <a href={whatsappLink("Hi, I'm interested in your used cars.")} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-gray-300 hover:text-white text-sm transition-colors" data-testid="footer-whatsapp">
              <MessageCircle size={18} className="text-[#25D366]" /> {t("footer.chat")}
            </a>
            <a href={CATALOGUE_URL} target="_blank" rel="noreferrer" className="text-gray-300 hover:text-white text-sm transition-colors" data-testid="footer-catalogue">
              {t("footer.catalogue")}
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-5 sm:px-8 max-w-7xl mx-auto flex flex-col sm:flex-row justify-between gap-2 text-xs text-gray-500">
        <span>© {new Date().getFullYear()} Shree Peteanjaneya Swamy Enterprises. {t("footer.rights")}</span>
        <Link to="/admin/login" className="hover:text-gray-300 transition-colors" data-testid="footer-admin-link">{t("footer.admin")}</Link>
      </div>
    </footer>
  );
};
